import * as React from 'react';

function SortIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={15} height={13} fill="none" {...props}>
      <path
        d="M4.977.898l2.625 2.625a.843.843 0 010 1.23.843.843 0 01-1.23 0L5.25 3.634V12c0 .492-.41.875-.875.875A.864.864 0 013.5 12V3.633l-1.148 1.12a.843.843 0 01-1.23 0 .843.843 0 010-1.23L3.745.898a.843.843 0 011.23 0zm9.625 9.106l-2.625 2.625a.843.843 0 01-1.23 0L8.12 10.004a.843.843 0 010-1.23.843.843 0 011.23 0l1.149 1.12V1.5c0-.465.383-.875.875-.875a.9.9 0 01.875.875v8.395l1.121-1.122a.843.843 0 011.23 0 .843.843 0 010 1.23z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoSortIcon = React.memo(SortIcon);
export default MemoSortIcon;
